import { render, staticRenderFns } from "./LabelSelectorAntV.vue?vue&type=template&id=c244d0d2&scoped=true"
import script from "./LabelSelectorAntV.vue?vue&type=script&lang=js"
export * from "./LabelSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./LabelSelectorAntV.vue?vue&type=style&index=0&id=c244d0d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c244d0d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c244d0d2')) {
      api.createRecord('c244d0d2', component.options)
    } else {
      api.reload('c244d0d2', component.options)
    }
    module.hot.accept("./LabelSelectorAntV.vue?vue&type=template&id=c244d0d2&scoped=true", function () {
      api.rerender('c244d0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/LabelSelectorAntV.vue"
export default component.exports